



















import {Vue, Component, Prop} from 'vue-property-decorator';
import SearchHold from "@/domainObjects/hold/SearchHold";
import TicketService from "../../services/TicketService";
import HoldTicket from "../../domainObjects/hold/HoldTicket";
import Defect from "../../domainObjects/hold/Defect";

@Component({
})

export default class DefectPicker extends Vue {
    @Prop({required: false}) data!: HoldTicket;
    @Prop({required: false}) selectMultiple!: Boolean;
    @Prop({required: false}) search!: SearchHold;

    private defects: Defect[] = [];
    private selectedDefect = {} as Defect;

    mounted() {
        TicketService.getDefects().then((response) => {
            for( let defect of response.data ) {
                let mappedDefects:Defect = {id: defect.id, desc: defect.desc, value: defect.id, text: defect.desc };
                this.defects.push(mappedDefects);
            }
            if (this.data && this.data.defect && this.data.defect.id){
                let i = this.defects.findIndex(defect => defect.value === this.data.defect.id);
                this.selectedDefect = this.defects[i];
            }
        }).catch((error)=>{
        });
    }
    selectDefect(event){
        let value = this.defects.filter(defect => defect.id == event.target.value);
        this.$emit('selectDefect', value[0])
    }

    invalidDefectSelected(){
        if (this.data.defect.id === 5 || this.data.defect.id === 8 || this.data.defect.id === 9){
            return true
        }
        return false
    }
}
